import { IProcessXetHocVuRequest } from "../../../model/request/xet-hoc-vu/IProcessXetHocVuRequest";
import { IXetLenLopViewModel } from "../../../model/response/xet-hoc-vu/IXetLenLopViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXetHocVuActionsObj = {
    LOAD_BY_DOT_XET_START: 0,
    LOAD_BY_DOT_XET_SUCCESS: {} as IXetLenLopViewModel[],
    LOAD_BY_DOT_XET_ERROR: "",

    XET_START: {} as IProcessXetHocVuRequest,
    XET_SUCCESS: "",
    XET_ERROR: "",

    CLOSE_PROCESSING_MODAL: undefined,

    SHOW_THAM_SO_MODAL: undefined,
    CLOSE_THAM_SO_MODAL: undefined,
    CHANGE_ID_DOT_XET: {} as number,
    CHANGE_ID_HE: {} as number,
    CHANGE_ID_KHOA: {} as number,
    CHANGE_KHOA_HOC: {} as number,
    CHANGE_ID_CHUYEN_NGANH: {} as number,
    CHANGE_ID_LOP: {} as number,
    CHANGE_IS_HIEN_THI_BO_LOC_LOP_XET: {} as boolean,
    CHANGE_ID_KHOI_NGANH: {} as number,
    CHANGE_IS_HIEN_THI_THEO_TRANG_THAI: {} as boolean,
}

export const eXetHocVuActionIds = generateActionTypeIds(eXetHocVuActionsObj, "XET_HOC_VU");
export type IXetHocVuActionTypes = IGenericActionType<typeof eXetHocVuActionsObj, "XET_HOC_VU">;